<template>
  <div class="nav" :class="{'fix': isFix }" v-if="!isMobile">
    <div class="container">
      <div class="logo">
        <img :src="isFix ? info.logo : info.logoW" alt="">
      </div>
      <div class="list">
        <div class="item" v-for="(item, i) in info.navList" :key="i">
          <a :href="item.url">{{item.name}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="nav-mobile" v-else>
    <div class="head" :class="{'show-menu': showMenu}">
      <div class="logo">
        <img :src="showMenu ? info.logo : info.logoW" alt="">
      </div>
      <div class="menu" @click="showMenu = !showMenu">
        <div class="nav-item">
          <a class="nav-hamburger" :class="{'is-active': showMenu}"><i></i><i></i><i></i></a>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="menu-list" v-if="showMenu" @click="showMenu = !showMenu">
        <div class="item" v-for="(item, i) in info.navList" :key="i">
          <a :href="item.url">{{item.name}}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFix: false,
      showMenu: false
    }
  },
  created () {
    const _this = this
    window.addEventListener('scroll', function() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      scrollTop >= 500 ? _this.isFix = true : _this.isFix = false
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex; align-items: center;
  width: 1140px;
  margin: 0 auto;
}
.nav {
  position: absolute; top: 0; left: 0; z-index: 2;
  padding: 16px 0 16px;
  width: 100%;

  &.fix {
    position: fixed; top: 0; left: 50%; z-index: 999;
    background: #FFF;
    transform: translateX(-50%);
    box-shadow: 0 0 20px 1px rgba($color: $black, $alpha: .1);
    & .list {
      & .item {
        & a {
          line-height: 22px;
          color: #353535;

          &:hover {
            color: $blue;
          }
        }
      }
    }
  }

  & .logo {
    flex: none;
    width: 125px;

    & img {
      display: block;
      width: 100%;
    }
  }

  & .list {
    display: flex;

    & .item {
      margin-left: 60px;

      & a {
        color: #FFF;
        @include font(16, 400);
      }
    }
  }
}

.nav-mobile {
  box-sizing: border-box;
  position: absolute; left: 0; top: 0; z-index: 90;
  padding: 0 20px;
  width: 100%; height: 60px;

  & .head {
    position: relative; z-index: 92;
    display: flex; justify-content: space-between;
    align-items: center;
    height: 60px;

    & .logo {
      width: 80px;

      & img {
        width: 100%;
      }
    }

    & .menu {
      & .nav-hamburger {
        display: block;
        width: 26px;
        height: 18px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        & i {
          background-color: #FFF;
          display: block;
          height: 2px;
          width: 100%;
          transition: all .3s ease-out;
        }
      }
    }

    &.show-menu {
      & .menu {
        & .nav-hamburger {
          & i {
            background-color: $black;
            &:nth-child(1) {
              width: 28px;
              transform: rotate(36deg);
              transform-origin: left top;
            }  
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              width: 28px;
              transform: rotate(-36deg);
              transform-origin: left bottom;
            }
          }
        }
      }
    }
  }

  & .menu-list {
    position: fixed; top: 0; left: 0; z-index: 91;
    padding-top: 53px;
    width: 100vw;
    height: calc(100vh - 53px);
    background: rgba($color: #FFF, $alpha: .9);

    & .item {
      margin: 0 auto;
      box-sizing: border-box;
      width: 96%;
      border-bottom: 1px solid rgba($color: $black, $alpha: .5);

      & a {
        display: block;
        padding: 18px 10px;
        color: $black;
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>